<section class="home wrap border-bottom">
    <div class="container mt-4 mb-4">
        <div class="row justify-content-center text-start">
            <div class="col-lg-8">
                <div class="card border-0 radius mb-4">
                    <div class="card-body p-4">
                        <h4 class="fw-bold color mb-4">{{userData.fullName}}'s answer</h4>
                        <div class="background-color p-3 radius mt-4 mb-4">
                            <h6 class="fw-bold">Question:</h6>
                            <p class="mb-2">"{{testQuestionData?.questionText}}"</p>
                            <h6 class="fw-bold">Answer:</h6>
                            <p class="mb-2">"{{testQuestionData?.userResponse}}"</p>
                        </div>
                        <form class="job-form mt-0" (ngSubmit)="submitManualFeedback()">
                            <div class="form-group">
                                <label for="score">
                                    <h6 class="fw-bold">Score:</h6>
                                </label>
                                <select id="score" name="score" class="form-control" [(ngModel)]="score">
                                    <option [ngValue]="null" disabled>{{testQuestionData?.score || 'Select score'}}
                                    </option> 
                                    <option [ngValue]="0">0</option>
                                    <option [ngValue]="0.5">0.5</option>
                                    <option [ngValue]="1">1</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="feedback">
                                    <h6 class="fw-bold">Feedback (optional):</h6>
                                </label>
                                <textarea class="preview-textarea" id="feedback" name="feedback" rows="3"
                                    placeholder="Submit a feedback to the applicant here..."
                                    [(ngModel)]="feedback"></textarea>
                            </div>

                            <button type="submit" class="submit-btn mt-2">Submit feedback</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>